import clsx from 'clsx';
import { Link } from 'react-router';

export function IconButton({
  children,
  className,
  disabled,
  type = 'button',
  variant = 'light',
  size = 'base',
  to,
  ...props
}) {
  const variants = {
    white: 'bg-white',
    light: 'bg-light',
  };

  const sizes = {
    base: 'w-[60px] h-[60px]',
    md: 'w-[50px] h-[50px]',
  };

  const commonClasses = clsx(
    'shrink-0 flex items-center justify-center rounded-full transition-colors text-primary-active hover:text-primary-active hover:bg-light-hover active:bg-light-active disabled:opacity-60 disabled:pointer-events-none',
    variants[variant],
    sizes[size],
    className,
  );

  if (to) {
    return (
      <Link
        to={to}
        className={clsx(commonClasses, {
          'opacity-60 pointer-events-none': disabled,
        })}
        {...props}
      >
        {children}
      </Link>
    );
  }

  return (
    <button type={type} className={commonClasses} disabled={disabled} {...props}>
      {children}
    </button>
  );
}
